import { Dispatch, RefObject, SetStateAction, useCallback, useMemo } from 'react';
import { throttle } from 'underscore';

const useHandleChange = ({
  setSearchValue,
  menuRef,
}: {
  menuRef: RefObject<HTMLDivElement | null>;
  setSearchValue: Dispatch<SetStateAction<string>>;
}) => {
  const throttledSetSearchValue = useMemo(() => {
    return throttle((value: string) => {
      menuRef?.current?.scrollTo({ top: 0 });
      setSearchValue(value);
    }, 300);
  }, [menuRef, setSearchValue]);

  return useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      throttledSetSearchValue(e.target.value);
    },
    [throttledSetSearchValue]
  );
};

export default useHandleChange;
